<template>
    <BTaginput ref="taginput" v-bind="$attrs">
        <template v-for="(_, name) in $slots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps || {}" />
        </template>
    </BTaginput>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, onUnmounted } from 'vue';
import { BTaginput } from 'buefy';

defineOptions({ inheritAttrs: false });

const taginput = ref(null);

function onDocMousedown(e) {
    const instance = taginput.value;
    if (!instance) return;
    // b-taginput holds its b-autocomplete at $refs.autocomplete
    const internalAc = instance.$refs?.autocomplete;
    if (!internalAc) return;
    const rootEl = instance.$el;
    const dropdownEl = internalAc.$refs?.dropdown;
    const outside = !rootEl?.contains(e.target) && !dropdownEl?.contains(e.target);
    if (outside) internalAc.isActive = false;
}

onMounted(() => document.addEventListener('mousedown', onDocMousedown));

onBeforeUnmount(() => {
    // Buefy's append-to-body manually moves the dropdown to <body> and removes it
    // in its own beforeUnmount. During Vue's route transitions the parent DOM is
    // already gone by then, making parentNode null and crashing the render.
    // Pre-emptively remove the body element here, before Buefy's hook runs.
    const internalAc = taginput.value?.$refs?.autocomplete;
    const bodyEl = internalAc?.$data?._bodyEl;
    if (bodyEl?.parentNode) {
        bodyEl.parentNode.removeChild(bodyEl);
        internalAc.$data._bodyEl = null;
    }
});

onUnmounted(() => document.removeEventListener('mousedown', onDocMousedown));
</script>
